// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { RedirectSourceEnum } from '../redirect-source-enum';

export const environment = {
  production: true,
  environment: 'staging',

  // the Application id for this specific app
  authAppId: 'S02Lyjm7nI8obupbE0NcOoRMtW6luArjsKBTz0nFlQc',

  // the successful login return url
  authRedirectURI: 'https://appstaging.reconcept.nl/login/success/',

  // the RedirectSource corresponding with backend
  authRedirectSource: RedirectSourceEnum.PORTFOLIO,

  // the requested grant scope
  authScope: 'user portfolio',

  bugsnagApiKey: '4311abaa44d12ffdb34c0cfe6da7b7f5',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
